//# sourceMappingURL=page_break.mjs.map
/// <reference types="./page_break.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $html_parser from "../../common/html_parser.mjs";
import * as $document_context from "../../data/docx/document_context.mjs";
import * as $kind from "../../data/docx/kind.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { Ok, Error, toList, prepend as listPrepend, CustomType as $CustomType } from "../../gleam.mjs";

export class PageBreak extends $CustomType {
  constructor(doc_context, break_type, html_tag, metadata) {
    super();
    this.doc_context = doc_context;
    this.break_type = break_type;
    this.html_tag = html_tag;
    this.metadata = metadata;
  }
}
export const PageBreak$PageBreak = (doc_context, break_type, html_tag, metadata) =>
  new PageBreak(doc_context, break_type, html_tag, metadata);
export const PageBreak$isPageBreak = (value) => value instanceof PageBreak;
export const PageBreak$PageBreak$doc_context = (value) => value.doc_context;
export const PageBreak$PageBreak$0 = (value) => value.doc_context;
export const PageBreak$PageBreak$break_type = (value) => value.break_type;
export const PageBreak$PageBreak$1 = (value) => value.break_type;
export const PageBreak$PageBreak$html_tag = (value) => value.html_tag;
export const PageBreak$PageBreak$2 = (value) => value.html_tag;
export const PageBreak$PageBreak$metadata = (value) => value.metadata;
export const PageBreak$PageBreak$3 = (value) => value.metadata;

export class Page extends $CustomType {}
export const BreakType$Page = () => new Page();
export const BreakType$isPage = (value) => value instanceof Page;

export class Column extends $CustomType {}
export const BreakType$Column = () => new Column();
export const BreakType$isColumn = (value) => value instanceof Column;

export class Line extends $CustomType {}
export const BreakType$Line = () => new Line();
export const BreakType$isLine = (value) => value instanceof Line;

export class Metadata extends $CustomType {
  constructor(kind) {
    super();
    this.kind = kind;
  }
}
export const Metadata$Metadata = (kind) => new Metadata(kind);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$kind = (value) => value.kind;
export const Metadata$Metadata$0 = (value) => value.kind;

function break_type_decoder() {
  return $decode.then$(
    $decode.string,
    (string) => {
      if (string === "page") {
        return $decode.success(new Page());
      } else if (string === "column") {
        return $decode.success(new Column());
      } else if (string === "line") {
        return $decode.success(new Line());
      } else {
        return $decode.failure(new Page(), "break_type");
      }
    },
  );
}

function metadata_decoder() {
  return $decrypt.optional_field(
    "kind",
    $kind.decoder(),
    (kind) => { return $decode.success(new Metadata(kind)); },
  );
}

export function decoder() {
  return $decrypt.optional_field(
    "doc_context",
    $document_context.decoder(),
    (doc_context) => {
      return $decrypt.optional_field(
        "break_type",
        break_type_decoder(),
        (break_type) => {
          let break_type$1 = $option.unwrap(break_type, new Page());
          return $decrypt.optional_field(
            "html_tag",
            $decode.string,
            (html_tag) => {
              let html_tag$1 = $option.unwrap(html_tag, "");
              return $decrypt.optional_field(
                "metadata",
                metadata_decoder(),
                (metadata) => {
                  let metadata$1 = $option.unwrap(
                    metadata,
                    new Metadata(new None()),
                  );
                  return $decode.success(
                    new PageBreak(
                      doc_context,
                      break_type$1,
                      html_tag$1,
                      metadata$1,
                    ),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function break_type_to_string(break_type) {
  if (break_type instanceof Page) {
    return "page";
  } else if (break_type instanceof Column) {
    return "column";
  } else {
    return "line";
  }
}

export function to_html(page_break) {
  let break_type_str = break_type_to_string(page_break.break_type);
  let break_type_attr = $a.attribute("data-break-type", break_type_str);
  let $ = page_break.doc_context;
  if ($ instanceof Some) {
    let ctx = $[0];
    let doc_context_attrs = $document_context.to_html_attributes(ctx);
    return $h.hr(listPrepend(break_type_attr, doc_context_attrs));
  } else {
    return $h.br(toList([]));
  }
}

function encode_break_type(break_type) {
  if (break_type instanceof Page) {
    return $json.string("page");
  } else if (break_type instanceof Column) {
    return $json.string("column");
  } else {
    return $json.string("line");
  }
}

function break_type_from_string(break_type) {
  if (break_type === "page") {
    return new Page();
  } else if (break_type === "column") {
    return new Column();
  } else if (break_type === "line") {
    return new Line();
  } else {
    return new Page();
  }
}

export function encode(page_break) {
  return $json.object(
    toList([
      ["type", $json.string("break")],
      [
        "doc_context",
        $json.nullable(page_break.doc_context, $document_context.encode),
      ],
      ["break_type", encode_break_type(page_break.break_type)],
      ["html_tag", $json.string(page_break.html_tag)],
      ["metadata", $json.object(toList([]))],
    ]),
  );
}

export function from_html(html) {
  let _block;
  let _pipe = $string.trim(html);
  _block = $string.starts_with(_pipe, "<hr");
  let is_page_break = _block;
  return $bool.guard(
    !is_page_break,
    new Error(undefined),
    () => {
      let element = $html_parser.as_tree(html);
      let doc_context = $document_context.from_html_attributes(element);
      let _block$1;
      let _pipe$1 = $html_parser.extract_attribute("data-break-type", element);
      let _pipe$2 = $result.unwrap(_pipe$1, "page");
      _block$1 = break_type_from_string(_pipe$2);
      let break_type = _block$1;
      return new Ok(
        new PageBreak(
          new Some(doc_context),
          break_type,
          "",
          new Metadata(new $option.None()),
        ),
      );
    },
  );
}

export function update_kind(page_break, kind) {
  let metadata = new Metadata(new Some(kind));
  return new PageBreak(
    page_break.doc_context,
    page_break.break_type,
    page_break.html_tag,
    metadata,
  );
}
